import { AnimatedSprite } from 'pixi.js';

export const blockedUnlockFrames = [
  'Unlock_Frame_2',
  'Unlock_Frame_3',
  'Unlock_Frame_4',
  'Unlock_Frame_5',
  'Unlock_Frame_6',
  'Unlock_Frame_7',
  'Unlock_Frame_8',
  'Unlock_Frame_9',
  'Unlock_Frame_10',
  'Unlock_Frame_11',
  'Unlock_Frame_12',
  'Unlock_Frame_12',
];

export function createBlockerLockedSprite(): AnimatedSprite {
  const sprite = AnimatedSprite.fromFrames(blockedUnlockFrames);
  sprite.anchor.set(0.5, 0.5);
  sprite.animationSpeed = 0.3;
  sprite.loop = false;
  return sprite;
}
